export class Contract_Event{
  constructor(
    public ID:number,
    public type:string,
    private parent_name:string,
    private person_name:string,
    private address:string,
    private phone:string,
    private address_service:string,
    private pay_form:string,
    public Contract_ID:number,
    public cancel_description:string,
    public embalming:string,
    public church:string,
    public aditional_service:string
  )
  {

  }
}



// WEBPACK FOOTER //
// /home/isai/funeraria/src/app/models/contract_event.model.ts